import { render } from "./CriarNovoVoucher.vue?vue&type=template&id=7f328ad4&scoped=true"
import script from "./CriarNovoVoucher.vue?vue&type=script&lang=js"
export * from "./CriarNovoVoucher.vue?vue&type=script&lang=js"

import "./CriarNovoVoucher.vue?vue&type=style&index=0&id=7f328ad4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f328ad4"]])

export default __exports__